import { uiSurface } from "shared/ui/uiSurface"
import { Box, Card, CardContent, Stack, Typography } from "@mui/material"
import { FC } from "react"
import { useTranslation } from "react-i18next"
import { DashboardAverageServiceTimeChart } from "./DashboardAverageServiceTimeChart"
import { DashboardDeliveredReturnedOrdersChart } from "./DashboardDeliveredReturnedOrdersChart"
import { DashboardLabelsChart } from "./DashboardLabelsChart"
import { DashboardMapCustomersWithRecurringOrders } from "./DashboardMapCustomersWithRecurringOrders"
import { DashboardWorkloadChart } from "./DashboardWorkloadChart"

const metricCards = [
  { label: "dashboard.kpi.success", value: "1" },
  { label: "dashboard.kpi.unsuccess", value: "0" },
  { label: "dashboard.kpi.avgDelivery", value: "N/A" },
  { label: "dashboard.kpi.avgService", value: "N/A" },
] as const

export const DashboardPage: FC = () => {
  const { t } = useTranslation()

  return (
    <Box
      data-testid="dashboard-page"
      sx={{
        p: { xs: 2, md: 3 },
        display: "flex",
        flexDirection: "column",
        gap: 2.5,
        bgcolor: "grey.50",
      }}
    >
      <Box>
        <Typography variant="h4" fontWeight={700} color="text.primary">
          {t("dashboard.title")}
        </Typography>
        <Typography variant="body1" color="text.secondary" sx={{ mt: 0.5 }}>
          {t(
            "dashboard.subtitle",
            "Monitor operational performance and delivery activity at a glance.",
          )}
        </Typography>
      </Box>

      <Stack
        {...uiSurface("UI-DLV2-071")}
        direction={{ xs: "column", md: "row" }}
        spacing={2}
      >
        {metricCards.map((metric) => (
          <Card
            key={metric.label}
            data-testid={`dashboard-kpi-${metric.label}`}
            variant="outlined"
            sx={{
              flex: 1,
              borderRadius: 2,
              minHeight: 96,
              bgcolor: "background.paper",
            }}
          >
            <CardContent sx={{ py: 2, px: 2.25 }}>
              <Typography
                variant="caption"
                color="text.secondary"
                sx={{ textTransform: "uppercase", letterSpacing: 0.5 }}
              >
                {t(metric.label)}
              </Typography>
              <Typography variant="h5" fontWeight={700} sx={{ mt: 0.5 }}>
                {metric.value}
              </Typography>
            </CardContent>
          </Card>
        ))}
      </Stack>

      <Stack direction={{ xs: "column", xl: "row" }} spacing={2}>
        <DashboardAverageServiceTimeChart />
        <DashboardDeliveredReturnedOrdersChart />
      </Stack>

      <Stack direction={{ xs: "column", xl: "row" }} spacing={2}>
        <DashboardWorkloadChart />
        <DashboardLabelsChart />
      </Stack>

      <DashboardMapCustomersWithRecurringOrders />
    </Box>
  )
}
